import React, { useState } from "react";
import { useTranslation } from "../../i18n/TranslationProvider";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers";
import { ResetPasswordSchema } from "./validations/authenticationSchema";
import { useLocation, useHistory } from "react-router-dom";
import { resetPassword } from "../../api/auth";

import { Row, Form } from "react-bootstrap";
import Sallie from "../UIComponents/Sallie";
import SubmitButton from "../UIComponents/SubmitButton";
import LabelledInput from "../UIComponents/LabelledInput";

const ResetPassword = () => {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const { register, handleSubmit, errors, formState } = useForm({
    resolver: yupResolver(ResetPasswordSchema),
  });
  const { touched } = formState;
  const url = new URLSearchParams(location.search);
  let token = url.get("token");

  const [sallieMsg, setSallieMsg] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [resetSuccess, setResetSuccess] = useState(false);

  const onSubmit = (data) => {
    setIsLoading(true);
    data.token = token;
    resetPassword(data)
      .then(() => {
        setSallieMsg(t("resetpassword.sallie.success"));
        setResetSuccess(true);
      })
      .catch((error) => {
        console.error(error);
        if (error.response) {
          if (error.response.status === 400) {
            setSallieMsg(t("resetpassword.sallie.invalid_token"));
          } else if (error.response.status === 403) {
            setSallieMsg(t("resetpassword.sallie.expired_token"));
          }
        } else {
          setSallieMsg(t("resetpassword.sallie.error"));
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      <Sallie text={sallieMsg || t("resetpassword.sallie.default")} />
      {resetSuccess ? (
        <SubmitButton onClick={() => history.push("/signIn")}>
          {t("resetpassword.go_to_login")}
        </SubmitButton>
      ) : (
        <Row className="d-flex justify-content-center">
          <Form
            autoComplete="on"
            method="POST"
            className="mt-2 d-flex flex-column align-items-center"
            style={{ margin: "0 auto" }}
            onSubmit={handleSubmit(onSubmit)}
          >
            <LabelledInput
              name="password"
              type="password"
              label={t("resetpassword.password")}
              inputRef={register}
              errors={errors}
              touched={touched}
            />
            <LabelledInput
              type="password"
              name="passwordConfirmation"
              label={t("resetpassword.confirm_password")}
              autoComplete="new-password"
              inputRef={register}
              errors={errors}
              touched={touched}
            />
            <SubmitButton disabled={isLoading} type="submit">
              {t("resetpassword.button")}
            </SubmitButton>
          </Form>
        </Row>
      )}
    </>
  );
};

export default ResetPassword;